module.exports = __webpack_public_path__ + "media/logos/dekra-26fb0f53.svg";